import { useEffect, useState } from "react";
import apiClient from "../Services/ApiClient";

const useGetData = <T>(url: string, config = {}) => {
  const [fieldData, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient(url, {
        method: 'GET',
        ...config,
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const data = await response.json();
      setData(data);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      setError(error.message || "An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [url]);

  return [fieldData, loading, error, fetchData] as const;
};

export default useGetData;